export { FilesAiIcon } from './FilesAIIcon';
export { FilesDefaultIcon } from './FilesDefaultIcon';
export { FilesEmptyIcon } from './FilesEmptyIcon';
export { FilesPdfIcon } from './FilesPDFIcon';
export { FilesPptIcon } from './FilesPPTIcon';
export { FilesSheetIcon } from './FilesSheetIcon';
export { Files3dIcon } from './Files3DIcon';
